import queryString from 'query-string';
import { useThrottleFn } from 'react-use';

import { localPreferences } from 'app-components/utils/core';

import { useSharedSessionState } from 'components/Dialogs/AuthDialog/hooks';
import useAuthURL from 'components/Dialogs/AuthDialog/useAuthURL';

let redirected = false;

function Automation() {
  const authURL = useAuthURL();
  const [sharedSessionState] = useSharedSessionState();
  useThrottleFn(
    () => {
      const query: {
        session_state?: string;
        code?: string;
        remember_me?: string;
      } = queryString.parse(window.location.search);
      if (process.env.SERVICE_ENV !== 'prod') {
        if (query.code && query.session_state) {
          const remoteSessionState = atob(decodeURIComponent(query.session_state));
          localPreferences.setKeepLoggedIn(Boolean(query.remember_me));
          window.parent?.postMessage(
            {
              type: 'auth',
              code: query.code,
              sessionState: remoteSessionState,
              automation: true,
            },
            window.origin,
          ); // send message event to iframe parent
        } else if (!redirected) {
          redirected = true;
          sessionStorage.setItem('sessionState', sharedSessionState);
          window.location.href = authURL;
        }
      }
    },
    1000,
    [authURL, sharedSessionState],
  );

  return null;
}

export const Component = Automation;
export default Automation;
